/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Roles_Is_Manually_AssignedInputs */

const en_tables_roles_is_manually_assigned = /** @type {(inputs: Tables_Roles_Is_Manually_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Manually Assigned`)
};

const de_tables_roles_is_manually_assigned = /** @type {(inputs: Tables_Roles_Is_Manually_AssignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuell zugewiesen`)
};

/**
* | output |
* | --- |
* | "Is Manually Assigned" |
*
* @param {Tables_Roles_Is_Manually_AssignedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_roles_is_manually_assigned = /** @type {((inputs?: Tables_Roles_Is_Manually_AssignedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Roles_Is_Manually_AssignedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_roles_is_manually_assigned(inputs)
	return de_tables_roles_is_manually_assigned(inputs)
});